import React, { createContext, useContext, useState, useEffect } from "react";

const ShopContext = createContext();

export const ShopProvider = ({ children }) => {
  const [shopId, setShopId] = useState(localStorage.getItem("shopId") || "");
  const [token, setToken] = useState(localStorage.getItem("tokenString") || "");
  const [shopName, setshopName] = useState(localStorage.getItem("shopName") || "");
  const [userId, setuserId] = useState(localStorage.getItem("userId") || "");
  const [userName, setuserName] = useState(localStorage.getItem("userName") || "");
  const [companyId, setcompanyId] = useState(localStorage.getItem("companyId") || "");
  const [groupId, setGroupId] = useState(localStorage.getItem("groupId") || "");

  // Sync localStorage whenever values change
  useEffect(() => {
    localStorage.setItem("shopId", shopId);
    localStorage.setItem("tokenString", token);
    localStorage.setItem("shopName", shopName);
    localStorage.setItem("userId", userId);
    localStorage.setItem("userName", userName);
    localStorage.setItem("companyId", companyId);
    localStorage.setItem("groupId", groupId);
  }, [shopId, token, shopName, userId, userName, companyId, groupId]);

  const logout = () => {
    localStorage.clear(); // ✅ clear all session data
    setShopId("");
    setToken("");
    setshopName("");
    setuserId("");
    setuserName("");
    setcompanyId("");
    setGroupId("");
    window.location.replace("/"); // redirect to login
  };

  return (
    <ShopContext.Provider
      value={{
        shopId,
        setShopId,
        token,
        setToken,
        shopName,
        setshopName,
        userId,
        setuserId,
        userName,
        setuserName,
        companyId,
        setcompanyId,
        groupId,
        setGroupId,
        logout,
      }}
    >
      {children}
    </ShopContext.Provider>
  );
};

export const useShop = () => useContext(ShopContext);
